const baseURL = 'https://apertai.uc.r.appspot.com';

// Tipos
export interface Camera {
  id: string;
  name: string;
  streamUrl: string;
}

export interface Livestream {
  id: string;
  arenaName: string;
  courtName: string;
  city: string;
  state: string;
  thumbnailUrl?: string;
  scheduledAt?: string;
  startedAt?: string;
  endedAt?: string;
  cameras: Camera[];
  viewerCount?: number;
  isLive: boolean;
  status: 'scheduled' | 'live' | 'ended';
}

// Busca todas as livestreams ativas (ao vivo agora)
export const getActiveLivestreams = async (): Promise<Livestream[]> => {
  const response = await fetch(`${baseURL}/livestream/active`);

  if (!response.ok) {
    throw new Error('Erro ao buscar livestreams ativas');
  }

  return await response.json();
};

// Busca todas as livestreams agendadas
export const getScheduledLivestreams = async (): Promise<Livestream[]> => {
  const response = await fetch(`${baseURL}/livestream/scheduled`);

  if (!response.ok) {
    throw new Error('Erro ao buscar livestreams agendadas');
  }

  return await response.json();
};

// Busca uma livestream específica pelo ID
export const getLivestreamById = async (id: string): Promise<Livestream> => {
  const response = await fetch(`${baseURL}/livestream/${id}`);

  if (!response.ok) {
    throw new Error('Livestream não encontrada');
  }

  return await response.json();
};

// Agenda uma nova livestream (requer autenticação)
export const scheduleLivestream = async (data: {
  courtId: string;
  subCourtId: string;
  scheduledAt: string;
  duration: number; // em minutos
  cameraIds: string[];
}): Promise<Livestream> => {
  const accessToken = localStorage.getItem('accessToken');

  const response = await fetch(`${baseURL}/livestream/schedule`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error('Erro ao agendar livestream');
  }

  return await response.json();
};

// Cancela uma livestream agendada
export const cancelLivestream = async (id: string): Promise<void> => {
  const accessToken = localStorage.getItem('accessToken');

  const response = await fetch(`${baseURL}/livestream/${id}/cancel`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    throw new Error('Erro ao cancelar livestream');
  }
};

// Busca livestreams do usuário logado (agendadas e passadas)
export const getMyLivestreams = async (): Promise<Livestream[]> => {
  const accessToken = localStorage.getItem('accessToken');

  const response = await fetch(`${baseURL}/livestream/my`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    throw new Error('Erro ao buscar suas livestreams');
  }

  return await response.json();
};
